/**
 * @summary 公共的重复的bridgeHandlers
 */

import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "./dsBridge";

// 客服
export const onCustomerService = () => {
	bridge.call(BridgeCallHandlers.ON_CUSTOMER_SERVICE_BUTTON_CLICK);
};

// 关闭页面
export const onCloseWebPage = () => {
	bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
};

// 调用系统反馈
export const onInvokeHapticEngine = () => {
	bridge.call(BridgeCallHandlers.ON_INVOKE_HAPTIC_ENGINE, {
		key: "style",
		value: "rigid",
	});
};
